export default __webpack_public_path__ + "static/media/fusion-export.010ac5f2.png";